/* eslint-disable */
import Vue from 'vue'
import Vuex from 'vuex'
import * as store from '@/store/modules/store.js' // * imports all public items
import * as map from '@/store/modules/map.js' // * imports all public items
import * as notification from '@/store/modules/notification.js' // * imports all public items
import * as etermin from '@/store/modules/etermin.js' // * imports all public items

Vue.use(Vuex)

export default new Vuex.Store({
    modules: {
        store, // use this module
        map, // use this module
        notification,
        etermin
    },
    state: {
        selectedStore: null, // the selected store from map
        proceed: false,
        initialPopup: true, // starting Popup
        loading: { // Loading object
            status: true,
            message: 'Loading...',
            error: false
        }
    },
    mutations: {
        SET_STORE (state, data) {
            if (data) {
                state.selectedStore = data.store
                state.selectedStore.source = data.source
            } else {
                state.selectedStore = null
            }
        },
        SET_LOADING (state, data) {
            state.loading.message = data.message
            state.loading.status = true
            state.loading.error = false
        },
        STOP_LOADING (state, data) {
            state.loading.status = 'Loading ...'
            state.loading.status = false
        },
        ERROR_LOADING (state, data) {
            state.loading.error = true
        },
        REMOVE_INITIAL_POPUP (state, data) {
            state.initialPopup = false
        },
        OPEN_INITIAL_POPUP (state, data) {
            state.initialPopup = true
        },
        SET_PROCEED (state, data) {
            state.proceed = data
        }
    },
    actions: {
        setStore ({ commit }, data) {
            commit('SET_STORE', data)
        },
        startLoading ({ commit, dispatch }, data) {
            commit('SET_LOADING', data)
        },
        errorLoading ({ commit }) {
            commit('ERROR_LOADING', {})
        },
        stopLoading ({ commit }) {
            commit('STOP_LOADING', {})
        },
        openIntitalPopup ({ commit }) {
            commit('OPEN_INITIAL_POPUP', {})
        },
        removeIntitalPopup ({ commit }) {
            commit('REMOVE_INITIAL_POPUP', {})
        },
        activateProceed ({ commit }) {
            commit('SET_PROCEED', true)
        },
        skipProceed ({ commit }) {
            commit('SET_PROCEED', false)
        }
    }

})
